export default {
  common: {
    search: 'Search',
    reset: 'Reset',
    save: 'Save',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submit: 'Submit',
    add: 'Add',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    enabled: 'Enabled',
    disabled: 'Disabled',
    invalidate: 'Invalidate',
    actions: 'Actions',
    status: 'Status',
    created: 'Created',
    updated: 'Updated',
    years: '{n} years',
    months: '{n} months',
    yearUnit: 'years',
    monthUnit: 'months',
    yes: 'Yes',
    no: 'No',
    all: 'All',
    keyword: 'Keyword',
    unknown: 'Unknown',
    none: 'None',
    noData: 'No data',
    error: 'Error',
    requestError: 'Request Error',
    pleaseSelect: 'Please select',
    pleaseEnter: 'Please enter',
    copy: 'Copy',
    copiedToClipboard: 'Copied to clipboard',
    uploadSizeHint: 'Up to {n}MB per file',
    fileTooLarge: 'File too large (max {n}MB)',
    requestTooLarge: 'Upload too large. Please compress the file to under {n}MB and try again',
    lastLogin: 'Last Login',
    language: 'Language',
    english: 'English',
    chinese: '中文',
    logout: 'Logout',
    changeEmail: 'Change Email',
    sendCode: 'Send Code',
    verificationCode: 'Verification Code',
    description: 'Description',
    remark: 'Remark',
    address: 'Address',
    phone: 'Phone',
    contact: 'Contact',
    code: 'Code',
    name: 'Name',
    type: 'Type',
    price: 'Price',
    min: 'Min',
    max: 'Max',
    startDate: 'Start Date',
    endDate: 'End Date',
    selectDate: 'Select Date',
    sort: 'Sort',
    sales: 'Sales',
    detail: 'Detail',
    pending: 'Pending',
    completed: 'Completed',
    archived: 'Archived',
    approved: 'Approved',
    rejected: 'Rejected',
    active: 'Active',
    expired: 'Expired',
    voided: 'Voided',
    on: 'On',
    off: 'Off',
    product: 'Product',
    service: 'Service',
    package: 'Package',
    agent: 'Agent',
    loadingFailed: 'Failed to load',
    savedSuccessfully: 'Saved successfully',
    updatedSuccessfully: 'Updated successfully',
    createdSuccessfully: 'Created successfully',
    deletedSuccessfully: 'Deleted successfully',
    operationFailed: 'Operation failed',
    batchNoteUpdatedSuccessfully: 'Batch note updated successfully',
    uploadImage: 'Upload image',
    uploading: 'Uploading...',
    uploadFailed: 'Upload failed'
  },
  status: {
    onSale: 'On Sale',
    offSale: 'Off Sale',
    registered: 'Registration on File',
    unregistered: 'No Registration Yet',
    invalid: 'Invalid',
    pendingReview: 'Pending Review',
    onHold: 'On Hold',
    active: 'Active',
    rejected: 'Rejected'
  },
  validation: {
    required: 'This field is required',
    requiredEmail: 'Please enter email',
    requiredCode: 'Please enter verification code',
    invalidEmail: 'Invalid email format',
    codeLength6: 'Code must be 6 digits',
    requiredUsername: 'Please enter username',
    requiredNickname: 'Please enter nickname',
    requiredOwnerName: 'Please enter owner name',
    requiredStoreName: 'Please enter store name',
    requiredLoginEmail: 'Please enter login email',
    requiredAgent: 'Please select agent',
    requiredMember: 'Please select member',
    requiredStore: 'Please select store',
    requiredCategory: 'Please select product type',
    requiredModel: 'Please select product model',
    requiredProductName: 'Please enter product name',
    requiredProductCode: 'Please enter product code',
    requiredProductType: 'Please select product type',
    requiredSalePrice: 'Please enter sale price',
    requiredStatus: 'Please select status',
    requiredPlateNumber: 'Please enter plate number',
    requiredEmployeeName: 'Please enter employee name',
    requiredEmployeeId: 'Please enter employee ID',
    requiredQuantity: 'Please enter quantity',
    requiredWarrantyYears: 'Please enter warranty period',
    requiredTypeCode: 'Please enter type code',
    requiredTypeName: 'Please enter product type name',
    requiredModelColorName: 'Please enter Finish/Color  name',
    typeCodePattern: 'Only uppercase letters, numbers, -, _ allowed',
    requiredPageCode: 'Please enter page code',
    requiredPageTitle: 'Please enter page title',
    requiredPageContent: 'Please enter page content',
    requiredFields: 'Please fill in required fields'
  },
  toast: {
    created: 'Created successfully',
    updated: 'Updated successfully',
    deleted: 'Deleted successfully',
    saved: 'Saved successfully',
    exported: 'Export successful',
    exportFailed: 'Export failed',
    loginSuccessful: 'Login successful',
    codeSent: 'Verification code sent',
    codeSendFailed: 'Failed to send code',
    loginFailed: 'Login failed',
    emailChanged: 'Email changed successfully',
    emailChangeFailed: 'Failed to change email',
    approved: 'Approved successfully',
    rejected: 'Rejected successfully',
    invalidated: 'Invalidated successfully',
    generated: 'Generated {n} serial numbers successfully',
    generateFailed: 'Failed to generate serial numbers',
    copied: 'Copied to clipboard',
    settingsSaved: 'Settings saved successfully'
  },
  menu: {
    group: {
      dashboard: 'Home',
      customerInfo: 'Customer Info',
      agency: 'Agency',
      productInfo: 'Product Info',
      website: 'Website Pages',
      profile: 'Change Email'
    }
  },
  route: {
    dashboard: 'Dashboard',
    myProducts: 'My Products',
    warrantySummary: 'Warranty Summary',
    warrantyRegister: 'Warranty Registration',
    warrantyDrafts: 'Registration Drafts',
    warranties: 'Warranty Records',
    vehicles: 'Vehicle Archives',
    members: 'Owner Archives',
    stores: 'Stores',
    storeEmployees: 'Store Employees',
    agents: 'Agents',
    products: 'Products',
    cmsPages: 'Website Pages',
    websiteCategories: 'Product Categories',
    websiteProducts: 'Website Products',
    websiteInstallations: 'Installations',
    websiteColors: 'Colors',
    websiteArticles: 'Insights & News',
    websiteAbout: 'About Page',
    traceCategories: 'Product Types',
    traceSpecifications: 'Product Models',
    traceCodes: 'My Products',
    traceInstallationAreas: 'Installation Areas',
    tracePackages: 'Packages',
    settings: 'Settings',
    profile: 'Change Email'
  },
  website: {
    common: {
      name: 'Name',
      nameEn: 'English Name',
      image: 'Image',
      slug: 'Slug',
      tabZh: '中文',
      tabEn: 'English',
      slugRequired: 'Please enter slug',
      slugPattern: 'Slug supports lowercase letters, digits and hyphens only',
      nameRequired: 'Please enter name',
      deleteConfirm: 'Delete "{name}"?'
    },
    categories: {
      title: 'Product Category Management',
      list: 'Categories',
      add: 'Add Category',
      edit: 'Edit Category',
      keywordPlaceholder: 'Name / Slug',
      summary: 'Summary',
      summaryEn: 'English Summary'
    },
    products: {
      title: 'Website Product Management',
      list: 'Products',
      add: 'Add Product',
      edit: 'Edit Product',
      keywordPlaceholder: 'Name / Slug',
      category: 'Category',
      categoryRequired: 'Please select a category',
      featured: 'Featured',
      featuredTag: 'Featured',
      descriptor: 'Descriptor',
      descriptorEn: 'English Descriptor',
      effect: 'Effect',
      effectEn: 'English Effect',
      installation: 'Installation',
      installationEn: 'English Installation',
      care: 'Care',
      careEn: 'English Care',
      warranty: 'Warranty',
      warrantyEn: 'English Warranty',
      seriesSection: 'Series & Models',
      seriesName: 'Series Name',
      addSeries: 'Add Series',
      modelCode: 'Model Code',
      modelDesc: 'Model Description',
      modelThickness: 'Thickness',
      addModel: 'Add Model',
      variantsSection: 'Variants (VLT)',
      addVariant: 'Add Variant',
      advantagesSection: 'Advantages',
      addAdvantage: 'Add Advantage',
      applicationsSection: 'Applications',
      addApplication: 'Add Application',
      specsSection: 'Specifications',
      specLabel: 'Label',
      specValue: 'Value',
      addSpec: 'Add Spec'
    },
    installations: {
      title: 'Installation Case Management',
      list: 'Installations',
      add: 'Add Installation',
      edit: 'Edit Installation',
      keywordPlaceholder: 'Title / Vehicle / Slug',
      vehicle: 'Vehicle',
      color: 'Color',
      products: 'Products',
      titleField: 'Title',
      titleEn: 'English Title',
      caption: 'Caption',
      captionEn: 'English Caption',
      area: 'Area',
      areaEn: 'English Area',
      make: 'Make',
      model: 'Model',
      year: 'Year'
    },
    colors: {
      title: 'Color Management',
      list: 'Colors',
      add: 'Add Color',
      edit: 'Edit Color',
      keywordPlaceholder: 'Name / Code / Slug',
      code: 'Color Code',
      codeRequired: 'Please enter color code',
      collection: 'Collection',
      collectionEn: 'English Collection',
      family: 'Family',
      familyEn: 'English Family',
      description: 'Description',
      descriptionEn: 'English Description',
      products: 'Products'
    },
    articles: {
      title: 'Insights & News Management',
      list: 'Articles',
      add: 'Add Article',
      edit: 'Edit Article',
      keywordPlaceholder: 'Title / Category / Slug',
      type: 'Type',
      typeRequired: 'Please select a type',
      insight: 'Insight',
      news: 'News',
      category: 'Category',
      categoryEn: 'English Category',
      excerpt: 'Excerpt',
      excerptEn: 'English Excerpt',
      readTime: 'Read Time',
      readTimeEn: 'English Read Time',
      publishDate: 'Publish Date',
      products: 'Products',
      bodySection: 'Body Sections',
      section: 'Section',
      headingZh: 'Heading (中文)',
      headingEn: 'Heading (English)',
      textZh: 'Text (中文)',
      textEn: 'Text (English)',
      addSection: 'Add Section'
    },
    about: {
      title: 'About Page Management',
      tip: 'Tip',
      tipText: 'Edit the whole "About Us" page here, in Chinese and English. If English is empty, the site falls back to Chinese.',
      pageTitle: 'Page Title',
      content: 'Content'
    }
  },
  login: {
    title: 'Auto Care Admin',
    emailPlaceholder: 'Email',
    codePlaceholder: '6-digit verification code',
    login: 'Login',
    sessionExpired: 'Your session has expired. Please log in again.',
    portalTitle: 'Log in to Business Portal',
    portalSubtitle: 'Use your email to receive a verification code and log in',
    emailLabel: 'Email Address',
    codeLabel: 'Verification Code',
    sendCodeHint: 'The verification code will be sent to your email.',
    applyDealer: 'Become a Partner',
    backToSite: 'Back to Official Website',
    footerBrand: 'SCOTT NOLES · BUSINESS PORTAL'
  },
  warrantyDrafts: {
    empty: 'No drafts. Content entered on the registration page is auto-saved as a draft.',
    goRegister: 'Go to Registration',
    summary: 'Draft Content',
    continueEdit: 'Continue Editing',
    confirmDelete: 'Delete this draft? This cannot be undone.',
    savedAt: 'Saved At',
    selectedAreas: 'Selected Areas'
  },
  warrantyRegister: {
    openTip: 'Warranty registration is completed on the official website. Click the button below to open the registration page in a new tab. If it did not open automatically, please check your browser popup settings.',
    openButton: 'Open Warranty Registration',
    ownerEmail: 'Owner Email',
    ownerName: 'Owner Name',
    ownerPhone: 'Owner Phone',
    installDate: 'Install Date',
    vehicleInfo: 'Vehicle Information',
    plateNumber: 'License Plate',
    vehicleState: 'State / Province',
    vehicleStatePlaceholder: 'Plate-issuing state / province',
    vehicleStateHint: 'Enter the issuing region with the plate; used to distinguish plates numbered by state/province',
    vinCode: 'VIN Code',
    brand: 'Brand',
    model: 'Model',
    color: 'Color',
    technician: 'Technician',
    traceCodes: 'Serial Numbers',
    traceCodePlaceholder: 'Enter serial numbers, separated by line breaks, commas, semicolons or spaces',
    traceCodeTip: 'Multiple serial numbers can be registered at once for the same vehicle and owner.',
    submit: 'Warranty Registration',
    submitSuccess: 'Warranty registration submitted, pending admin review',
    submitFailed: 'Failed to submit warranty registration',
    successTitle: 'Submitted',
    successSubtitle: '{count} warranty registration(s) submitted and pending admin approval',
    continueRegister: 'Continue Registering',
    ownerEmailRequired: 'Please enter owner email',
    ownerEmailInvalid: 'Invalid email format',
    ownerNameRequired: 'Please enter owner name',
    installDateRequired: 'Please select install date',
    traceCodesRequired: 'Please enter at least one serial number'
    ,
    tabVerify: 'Product Verification',
    tabDetails: 'Warranty Details',
    tabConfirm: 'Confirm Registration',
    verifyTitle: 'Verify Serial Number',
    verifyPlaceholder: 'Enter serial number',
    verifyButton: 'Verify',
    verifyTip: 'Enter serial numbers one by one to verify. Verified products will be included in this registration.',
    verifiedList: 'Products in This Registration',
    nextToDetails: 'Next: Warranty Details',
    verifyNoCode: 'Please verify at least one valid serial number first',
    status0: 'No Registration Yet',
    status1: 'Registration on File',
    status2: 'Invalidated',
    statusSuspended: 'Suspended',
    statusNotEligible: 'Not Eligible',
    verifyFailed: 'Failed to verify serial number',
    duplicatedCode: 'This serial number has already been verified',
    alreadyRegisteredTip: 'This serial number has been registered before. Re-registration is allowed and will be reviewed by an administrator.',
    registrationStats: 'Registered {n} time(s). Last registered: {time}',
    invalidCodeTip: 'This serial number has been invalidated and cannot be registered.',
    notEligibleTip: 'This product category does not support warranty registration and cannot be submitted.',
    productName: 'Product Name',
    spec: 'Product Attributes',
    attrMaterial: 'Material',
    attrFinish: 'Finish',
    attrColor: 'Color',
    attrThickness: 'Thickness',
    warrantyPeriod: 'Warranty Period',
    batchNo: 'Batch No.',
    finishColor: 'Finish / Color',
    sectionCustomer: 'Customer Information',
    sectionVehicle: 'Vehicle & Installation',
    emailHint: 'Used to receive review updates and the certificate after approval',
    installDateHint: 'Cannot be later than today',
    vinHint: 'Optional, up to 17 characters',
    requiredNote: '* Only owner email and install date are required; all other fields are optional.',
    backToVerify: 'Back to Verification',
    nextToConfirm: 'Next: Confirm Registration',
    backToEdit: 'Back to Edit',
    confirmSubmit: 'Confirm & Submit',
    confirmTitle: 'Please review the registration information below',
    confirmProducts: 'Products in This Registration',
    confirmCustomer: 'Customer Information',
    confirmVehicle: 'Vehicle & Installation',
    noData: 'Not provided',
    sectionProductInstall: 'Product & Installation',
    stepProductType: 'Select Product Type',
    productTypeHint: 'Product types are loaded from the database. Select the type matching the installed product.',
    noCategories: 'No active product types',
    // Level-1 categories like Specialty Protection require a sub-product first
    stepPackage: 'Select Package',
    pkgFull: 'Full Vehicle Protection',
    pkgFront: 'Front Protection',
    pkgRear: 'Rear Protection',
    pkgCustom: 'Individual Areas',
    pkgClear: 'Clear',
    sideLeft: 'Left',
    sideRight: 'Right',
    sideBoth: 'Both',
    selectSide: 'Select Side',
    stepAreas: 'Confirm Installation Areas',
    requireCategory: 'Please select a product type',
    requirePackage: 'Please select a package plan',
    requireAreas: 'Please select at least one installation area',
    noAreasSelected: 'No installation areas selected',
    areasSelectedPrefix: 'Selected',
    areasHint: 'Packages preselect included areas and remain editable. Bilateral parts support Left, Right, or Both.',
    stepVehicle: 'Vehicle & Installation Details',
    technicians: 'Installation Technicians',
    techniciansPlaceholder: 'Select or enter technician name',
    techniciansHint: 'Select multiple store technicians or add a new name',
    sectionPhotos: 'Photos & Documents',
    photosOptional: 'All optional',
    receiptLabel: 'Order or Receipt',
    receiptHint: 'JPG, PNG or PDF, up to 5MB per file',
    beforePhotos: 'Before Installation',
    beforePhotosHint: 'Multiple files, up to 5MB each',
    afterPhotos: 'After Installation',
    afterPhotosHint: 'Multiple files, up to 5MB each',
    uploadButton: 'Choose File',
    confirmProductType: 'Product Type',
    confirmPackage: 'Package',
    confirmAreas: 'Installation Areas',
    confirmPhotos: 'Photos & Documents',
    // Progress & product info (per docs/zhucezhibao.html reference)
    progressVerify: 'Verify',
    progressDetails: 'Details',
    progressSubmit: 'Submit',
    progressApproval: 'Approval',
    sectionProductInfo: 'Product Information',
    productModel: 'Product Model',
    thickness: 'Thickness',
    material: 'Material',
    rollReusable: 'Reusable',
    verifiedBannerTitle: 'Roll trace verified',
    verifiedBannerDesc: 'Product loaded · serial number remains reusable',
    addAnotherTip: 'All ScottNoles products are rolls. The serial number can be reused for compliant registrations; each approval adds an independent usage mark.',
    removeProduct: 'Remove',
    installNotes: 'Installation Notes',
    installNotesPlaceholder: 'Optional, additional installation details',
    // Privacy & warranty confirmation
    sectionLegal: 'Privacy & Warranty Confirmation',
    legalRequired: '2 Required',
    legalIntro: 'Open and review each official document, then complete the acknowledgement at the bottom of its window. The legal text follows the interface language (Chinese or official English).',
    privacyNotice: 'Privacy Notice',
    privacyNoticeDesc: 'Learn what information is collected during warranty registration, how it is used and retained, and the customer rights.',
    warrantyTerms: 'Limited Product Warranty',
    warrantyTermsDesc: 'Review applicable conditions, coverage, exclusions, claim process and installing store responsibilities.',
    reviewAcknowledge: 'Review & Acknowledge',
    reviewAccept: 'Review & Accept',
    reviewAgain: 'Review Again',
    notAcknowledged: 'Not acknowledged',
    notAccepted: 'Not accepted',
    acknowledged: 'Acknowledged',
    accepted: 'Accepted',
    legalHint: 'Registration can be submitted only after both confirmations are complete.',
    consentPrivacy: 'I have read and acknowledged the Privacy Notice and confirm that the relevant privacy information has been made available to the customer as required by applicable law.',
    consentWarranty: 'I have read and accepted the Limited Product Warranty and confirm that the registration information and supporting records are complete and accurate.',
    confirmAcceptance: 'Confirm Acceptance',
    closeLater: 'Close',
    // Draft
    saveDraft: 'Save Draft',
    draftSaved: 'Draft saved',
    draftAutosave: 'Autosave enabled',
    draftRestored: 'Previous draft restored',
    confirmStore: 'Store',
    confirmNotes: 'Installation Notes',
    confirmScope: 'Scope'
  },
  warrantyManage: {
    title: 'Warranty Records',
    keywordPlaceholder: 'Serial number / product model',
    traceCode: 'Serial Number',
    productName: 'Product Model',
    categoryName: 'Product Type',
    owner: 'Owner',
    ownerEmail: 'Owner Email',
    ownerPhone: 'Owner Phone',
    vehicle: 'Vehicle',
    store: 'Installing Store',
    agentBelong: 'Agent',
    installDate: 'Install Date',
    warrantyPeriod: 'Warranty Period',
    warrantyYears: 'Warranty Period',
    submittedAt: 'Submitted At',
    detailTitle: 'Warranty Details',
    productInfo: 'Product Information',
    ownerInfo: 'Owner Information',
    vehicleInfo: 'Vehicle Information',
    plateNumber: 'Plate Number',
    vehicleState: 'State / Province',
    vinCode: 'VIN',
    brand: 'Brand',
    model: 'Model',
    installers: 'Installers',
    installerName: 'Name',
    installerRole: 'Role',
    workScope: 'Work Scope',
    stage: 'Stage',
    reviewNote: 'Review Note',
    approve: 'Approve',
    approveTitle: 'Approve Warranty Registration',
    approveInstallDate: 'Confirmed Install Date',
    installDateHint: 'Defaults to the registered install date; the warranty period starts from this date',
    approveNote: 'Review Note',
    approveNotePlaceholder: 'Optional, will be recorded on the warranty',
    installDateRequired: 'Please select the confirmed install date',
    noteRequired: 'Please enter a note',
    approveSuccess: 'Approved',
    reject: 'Reject',
    rejectPrompt: 'Enter the rejection reason (will be shown to the registering store)',
    rejectSuccess: 'Rejected',
    requestRevision: 'Put on Hold',
    revisionPrompt: 'Enter the reason for putting on hold (will be shown to the registering store)',
    revisionSuccess: 'Put on hold',
    supplement: 'Supplement & Resubmit',
    supplementTitle: 'Supplement Materials',
    supplementDesc: 'Supplement or update the materials according to the hold reason; the warranty will return to Pending Review after submission.',
    supplementAfterRequired: 'Upload at least one after-installation photo',
    supplementSuccess: 'Resubmitted; pending admin review',
    status: {
      DRAFT: 'Draft',
      SUBMITTED: 'Submitted',
      UNDER_REVIEW: 'Under Review',
      NEEDS_REVISION: 'On Hold',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      CHANNEL_REVIEW: 'Channel Review',
      CANCELLED: 'Cancelled'
    }
  },
  profile: {
    title: 'Change Email',
    step1: 'Step 1: Verify Current Email',
    step2: 'Step 2: Enter New Email',
    currentEmail: 'Current email',
    newEmail: 'New Email',
    newEmailCode: 'New Email Code',
    newEmailPlaceholder: 'Enter new email',
    newEmailCodePlaceholder: 'Enter new email code',
    confirmChange: 'Confirm Change'
  },
  dashboard: {
    overviewTitle: 'Installation Overview',
    overviewSubtitle: 'Track installation orders and warranty application progress',
    scopePrefix: 'Current scope: ',
    scopeStore: 'This Store',
    scopeAgent: 'Stores under this agent',
    scopeAll: 'All Stores',
    monthlyOrders: 'Orders This Month',
    monthlyOrdersNote: '{month} · submitted orders',
    todayOrders: "Today's Orders",
    todayOrdersNote: 'By installation date',
    totalOrders: 'Total Orders',
    totalOrdersNote: 'Including pending, active and rejected orders',
    activeWarranties: 'Active Warranties',
    activeWarrantiesNote: 'Approved and activated',
    unitOrders: 'orders',
    unitWarranties: 'records',
    unitTip: 'Unit: orders',
    last6Months: 'Last 6 months',
    last12Months: 'Last 12 months',
    monthlyChartTitle: 'Monthly Installation Orders',
    warrantyStatusTitle: 'Warranty Registration Status',
    registeredTotal: 'Registered',
    statusPending: 'Pending',
    statusApproved: 'Active',
    statusRejected: 'Rejected',
    recentTitle: 'Recent Installation Orders',
    recentDesc: 'Newest first by registration time',
    viewAll: 'View All',
    colInstallDate: 'Install Date',
    colTraceCode: 'Serial Number',
    colOwnerEmail: 'Owner Email',
    colProductModel: 'Product Model',
    colStatus: 'Status',
    colActions: 'Actions',
    viewDetail: 'View Details',
    footerNote: 'A submitted application does not mean the warranty is active; please refer to the registration status.',
    detail: {
      title: 'Warranty Registration Details',
      subtitle: 'Review application materials and warranty activation progress',
      bannerPendingTitle: 'Application submitted, warranty not yet active',
      bannerPendingDesc: 'It will be activated after approval. Please refer to the registration status.',
      bannerApprovedTitle: 'Warranty Active',
      bannerApprovedDesc: 'This registration has been approved and the warranty is within its validity period.',
      bannerRejectedTitle: 'Registration Rejected',
      bannerRejectedDesc: 'This registration was not approved.',
      reviewNotePrefix: 'Review Note',
      sectionApplication: 'Application & Warranty',
      submittedAt: 'Submitted At',
      regStatus: 'Status',
      warrantyPeriodPending: '{n} year(s) (pending activation)',
      warrantyRange: 'Warranty Period',
      warrantyRangePending: 'To be confirmed after approval',
      warrantyRangeHint: 'The warranty period will be displayed according to brand rules once approved.',
      sectionProduct: 'Product & Installation',
      productModel: 'Product Model',
      productType: 'Product Type',
      installStore: 'Install Store',
      storeCode: 'Store Code',
      installers: 'Installers',
      sectionOwner: 'Owner Information',
      ownerPhone: 'Phone',
      notFilled: 'Not provided',
      sectionVehicle: 'Vehicle Information',
      sectionPhotos: 'Photos & Documents',
      optionalTag: 'All optional',
      invoices: 'Order or Proof of Purchase',
      beforePhotos: 'Before Photos',
      afterPhotos: 'After Photos',
      photoCount: '{n} photo(s)',
      notUploaded: 'No images uploaded',
      preview: 'Preview'
    }
  },
  members: {
    title: 'Owner Archives',
    list: 'Owner Archives',
    ownerName: 'Owner Name',
    ownerNamePlaceholder: 'Enter owner name',
    ownerDetail: 'Owner Archive Detail',
    editOwner: 'Correct Owner Archive',
    phone: 'Phone',
    phonePlaceholder: 'Enter phone',
    vehicleCount: 'Vehicles',
    warrantyCount: 'Warranty Records',
    vehicles: 'Linked Vehicles',
    warranties: 'Linked Warranty Records',
    warrantyPeriod: 'Warranty Period',
    traceCode: 'Serial Number',
    productName: 'Product',
    vehicleState: 'State / Province',
    vinCode: 'VIN Code',
    // shared with agent / store pages
    username: 'Username',
    nickname: 'Nickname',
    email: 'Email',
    emailPlaceholder: 'Enter email',
    usernamePlaceholder: 'Enter username',
    nicknamePlaceholder: 'Enter nickname',
    agent: 'Agent',
    store: 'Installing Store',
    brand: 'Brand',
    model: 'Model',
    color: 'Color',
    plate: 'Plate'
  },
  vehicles: {
    title: 'Vehicle Archives',
    list: 'Vehicle Archives',
    plateNumber: 'Plate Number',
    vehicleState: 'State / Province',
    vinCode: 'VIN Code',
    brand: 'Brand',
    model: 'Model',
    owner: 'Owner',
    ownerEmail: 'Owner Email',
    ownerPlaceholder: 'Enter owner name',
    warrantyCount: 'Warranty Records',
    vehicleDetail: 'Vehicle Archive Detail',
    editVehicle: 'Correct Vehicle Archive',
    vehicleCountry: 'Issuing Country / Region',
    warranties: 'Linked Warranty Records',
    warrantyPeriod: 'Warranty Period',
    traceCode: 'Serial Number',
    productName: 'Product',
    store: 'Installing Store',
    agent: 'Agent',
    platePlaceholder: 'Enter plate number',
    vinPlaceholder: '17-digit VIN code',
    plateExample: 'e.g. 京A12345',
    stateExample: 'e.g. California / Guangdong',
    brandExample: 'e.g. Toyota',
    modelExample: 'e.g. Camry',
    countryExample: 'e.g. China / USA'
  },
  agents: {
    title: 'Agents',
    list: 'Agent List',
    addAgent: 'Add Agent',
    editAgent: 'Edit Agent',
    agentDetail: 'Agent Detail',
    country: 'Country',
    stores: 'Stores',
    members: 'Members',
    emailVerified: 'Email Verified',
    noStores: 'No stores',
    storeName: 'Store Name',
    keywordPlaceholder: 'Username/Nickname',
    countryPlaceholder: 'Enter country',
    dealerIdUnchanged: 'Dealer ID cannot be changed',
    confirmEnable: 'Are you sure to {action} this agent?'
  },
  stores: {
    title: 'Stores',
    list: 'Store List',
    applyStore: 'Apply for New Store',
    editStore: 'Edit Store',
    storeCode: 'Store Code',
    storeName: 'Store Name',
    contactName: 'Contact Name',
    loginEmail: 'Login Email',
    storeAdminLoginEmail: 'Store admin login email',
    detailedAddress: 'Detailed Address',
    keywordPlaceholder: 'Store name/code',
    selectAgent: 'Select agent',
    codePlaceholder: 'Enter store code',
    namePlaceholder: 'Enter store name',
    contactPlaceholder: 'Enter contact name',
    country: 'Country/Region',
    countryPlaceholder: 'Select country/region',
    confirmDelete: 'Are you sure to delete this store?',
    confirmApprove: 'Are you sure to approve this store?',
    confirmReject: 'Are you sure to reject this store?',
    confirmEnable: 'Are you sure to {action} this store?'
  },
  storeEmployees: {
    title: 'Store Employees',
    list: 'Employee List',
    addEmployee: 'Add Employee',
    editEmployee: 'Edit Employee',
    employeeName: 'Name',
    employeeId: 'Installer ID',
    keywordPlaceholder: 'Name/Installer ID/Phone',
    namePlaceholder: 'Enter employee name',
    idPlaceholder: 'Auto-generated by system',
    status: 'Status',
    statusEnabled: 'Enabled',
    statusDisabled: 'Disabled',
    phonePlaceholder: 'Enter phone',
    selectStore: 'Select store',
    confirmDelete: 'Are you sure to delete this employee?'
  },
  products: {
    title: 'Products',
    list: 'Product List',
    addProduct: 'Add Product',
    editProduct: 'Edit Product',
    productDetail: 'Product Detail',
    productName: 'Product Name',
    productCode: 'Product Code',
    originalPrice: 'Original Price',
    salePrice: 'Sale Price',
    costPrice: 'Cost Price',
    profit: 'Profit',
    warranty: 'Warranty',
    warrantyMonths: 'Warranty (months)',
    thumbnail: 'Thumbnail',
    thumbnailTip: 'Thumbnail image URL',
    warrantyDesc: 'Warranty Description',
    applicableModels: 'Applicable Models',
    applicableBrands: 'Applicable Brands',
    detailContent: 'Detail Content',
    detailSectionDescription: 'Description',
    detailSectionWarranty: 'Warranty Description',
    detailSectionModels: 'Applicable Models',
    detailSectionBrands: 'Applicable Brands',
    detailSectionThumbnail: 'Thumbnail',
    keywordPlaceholder: 'Product name/code',
    namePlaceholder: 'Enter product name',
    codePlaceholder: 'Enter product code',
    typePlaceholder: 'Select type',
    descPlaceholder: 'Enter product description',
    warrantyDescPlaceholder: 'Enter warranty description',
    modelsPlaceholder: 'Enter applicable models, comma separated',
    brandsPlaceholder: 'Enter applicable brands, comma separated',
    detailPlaceholder: 'Enter detail content (HTML supported)',
    thumbnailPlaceholder: 'Enter image URL',
    monthsAppend: 'months',
    confirmDelete: 'Are you sure to delete this product?',
    confirmToggle: 'Are you sure to {action} this product?'
  },
  trace: {
    categories: {
      title: 'Product Types',
      list: 'Product Type List',
      add: 'Add Product Type',
      edit: 'Edit Product Type',
      typeCode: 'Type Code',
      typeName: 'Name',
      englishName: 'English Name',
      template: 'Template',
      warrantyYears: 'Warranty Period',
      codePlaceholder: 'e.g., PPF, COLOR',
      namePlaceholder: 'Enter product type name',
      englishPlaceholder: 'Enter English name',
      selectTemplate: 'Select template',
      uniqueCodeTip: 'Unique code, cannot be changed',
      planHint: 'Plan Hint (Chinese)',
      planHintEn: 'Plan Hint (English)',
      planHintPlaceholder: 'Hint shown on the warranty registration page after selecting this product type',
      planHintEnPlaceholder: 'English hint, displayed on a separate line from the Chinese text',
      planHintTip: 'Shown after "Select Product Type" on the registration page; a generic hint is used when left empty',
      allowDuplicate: 'Allow Re-registration',
      allowDuplicateTip: 'When on, the same serial number can be registered multiple times (each approval creates an independent record); when off, only one registration is allowed',
      showInWarranty: 'Show on Warranty Page',
      showInWarrantyTip: 'When off, this type is hidden from "Select Product Type" on the warranty registration page',
      confirmDelete: 'Are you sure to delete this product type?',
      confirmToggle: 'Are you sure to {action} this product type?'
    },
    specifications: {
      title: 'Product Model Management',
      list: 'Product Model List',
      add: 'Add Product Model',
      edit: 'Edit Product Model',
      template: 'Template',
      productType: 'Product Type',
      productModel: 'Product Model',
      modelColorNameCn: 'Finish/Color  Name (CN, admin only)',
      modelColorNameEn: 'Finish/Color Name (EN, public display)',
      fullSpecs: 'Full Specs',
      productAttributes: 'Product Attributes',
      warrantyYears: 'Warranty Period',
      internalNote: 'Internal Note',
      uniqueModelTip: 'Unique product model, cannot be changed',
      modelInfo: 'Model Info',
      selectProductType: 'Select product type',
      categoryDefaultTip: 'Leave empty to use category default',
      noTemplateHint: 'Please select a product type that has a template configured.',
      generateTraceCodes: 'Generate Serial Numbers',
      agent: 'Agent',
      quantity: 'Quantity',
      quantityTip: 'Maximum 1000 codes per generation',
      batchInfo: 'Batch Info',
      manufactureDate: 'Manufacture Date',
      batchNo: 'Batch No',
      generate: 'Generate',
      confirmDelete: 'Are you sure to delete this model?',
      confirmToggle: 'Are you sure to {action} this model?',
      generated: 'Generated {n} serial numbers successfully'
    },
    codes: {
      title: 'My Products',
      list: 'My Products',
      export: 'Export',
      traceCode: 'Serial Number',
      productModel: 'Product Model',
      product: 'Product',
      category: 'Product Type',
      material: 'Material',
      finish: 'Finish',
      color: 'Color',
      thickness: 'Thickness',
      warranty: 'Warranty',
      mfgDate: 'Mfg Date',
      batchNo: 'Batch No',
      batchInternalNote: 'Batch Internal Note',
      token: 'Token',
      distribution: 'Distribution',
      batchNumber: 'Batch number',
      traceCodePlaceholder: 'Serial number',
      selectCategory: 'Select category',
      selectModel: 'Select model',
      selectAgent: 'Select agent',
      productionBatchNumber: 'Production batch number',
      internalNoteAdmin: 'Internal note (admin only)',
      noBatchNote: 'No batch note',
      detailTitle: 'Serial Number Detail',
      publicInfo: 'Public Info',
      internalInfo: 'Internal Info (Admin)',
      supplier: 'Supplier',
      purchaseDate: 'Purchase Date',
      editNote: 'Edit Note',
      editInternalInfo: 'Edit Internal Info',
      editBatchNote: 'Edit Batch Internal Note',
      batchEdit: 'Batch Edit',
      editBatch: 'Edit Batch',
      createdTime: 'Created Time',
      batchEditTitle: 'Batch Update Batch Info',
      copyTitle: 'Copy Serial Number',
      batchEditTip: 'The changes below will be applied to the {n} selected serial numbers. Blank fields are left unchanged (registered codes are skipped automatically).',
      leaveBlankNoChange: 'Leave blank to keep unchanged',
      batchEditResult: 'Updated {n} serial numbers',
      batchEditResultSkipped: 'Updated {updated}, skipped {skipped} registered serial numbers',
      supplierName: 'Supplier name',
      remarkPlaceholder: 'Enter remark',
      enterInternalNote: 'Enter internal note',
      qrCode: 'QR Code',
      scanTip: 'Scan to verify authenticity',
      noBatchInfo: 'No batch information',
      confirmInvalidate: 'Are you sure to invalidate this serial number?'
    },
    installationAreas: {
      title: 'Installation Area Management',
      list: 'Installation Areas',
      add: 'Add Installation Area',
      edit: 'Edit Installation Area',
      areaCode: 'Area Code',
      areaName: 'Area Name',
      areaNameEn: 'English Name',
      group: 'Group',
      groupBody: 'Body Panels',
      groupLight: 'Light Protection',
      groupOther: 'Other',
      packages: 'Packages',
      pkgFull: 'Full Vehicle Protection',
      pkgFront: 'Front Protection',
      pkgRear: 'Rear Protection',
      pkgFullShort: 'Full',
      pkgFrontShort: 'Front',
      pkgRearShort: 'Rear',
      bilateral: 'Bilateral',
      keywordPlaceholder: 'Area name / code',
      codePlaceholder: 'e.g. FRONT_BUMPER',
      codeRequired: 'Please enter area code',
      codePattern: 'Code supports uppercase letters, digits, underscore and hyphen only',
      nameRequired: 'Please enter area name',
      groupRequired: 'Please select a group',
      deleteConfirm: 'Delete installation area "{name}"?'
    },
    packages: {
      title: 'Package Management',
      list: 'Packages',
      add: 'Add Package',
      edit: 'Edit Package',
      category: 'Product Type',
      selectCategory: 'Select product type',
      categoryRequired: 'Please select a product type',
      packageCode: 'Package Code',
      codePlaceholder: 'e.g. PPF_FULL',
      codeRequired: 'Please enter package code',
      codePattern: 'Code supports letters, digits, underscore and hyphen only',
      packageName: 'Package Name',
      packageNameEn: 'English Name',
      nameRequired: 'Please enter package name',
      areas: 'Included Areas',
      noAreas: 'No active installation areas. Add areas first.',
      autoApply: 'Auto Apply',
      autoApplyTip: 'When enabled, selecting this product type on warranty registration applies this package automatically',
      keywordPlaceholder: 'Package name / code',
      categoryAreasTitle: 'Category Areas (Registration Step 03 Candidates)',
      categoryAreasConfigured: 'Candidate areas configured: unchecked areas are hidden from this product type at registration step 03',
      categoryAreasNotConfigured: 'No candidate areas configured: all active areas are shown at registration step 03',
      categoryAreasHint: 'Save with no areas checked = clear configuration (show all)',
      deleteConfirm: 'Delete package "{name}"?'
    },
    template: {
      PPF: {
        name: 'Paint Protection Film',
        fields: {
          material: { label: 'Base Film', placeholder: 'e.g. TPU' },
          thickness: { label: 'Thickness', placeholder: 'e.g. 7.5MIL' },
          internalNote: { label: 'Internal Note' }
        }
      },
      TPU_COLOR_PPF: {
        name: 'Colored Paint Protection Film',
        fields: {
          material: { label: 'Base Film', placeholder: 'e.g. TPU' },
          colorCode: { label: 'Color Code', placeholder: 'e.g. SN-P1-001-SG' },
          colorName: { label: 'Color Name', placeholder: 'e.g. Gloss Soft Cheek Peach Pink' },
          thickness: { label: 'Thickness', placeholder: 'e.g. 7.5MIL' },
          internalNote: { label: 'Internal Note' }
        }
      },
      CUSTOM_PRINTED: {
        name: 'Custom Printed Wrap Film',
        fields: {
          material: { label: 'Base Film', placeholder: 'e.g. Vinyl' },
          finish: { label: 'Print Process', placeholder: 'e.g. Digital Inkjet Printing' },
          colorCode: { label: 'Base Film Type', placeholder: 'e.g. 160g PET Vinyl' },
          internalNote: { label: 'Internal Note' }
        }
      },
      WINDOW_FILM: {
        name: 'Automotive Window Film',
        fields: {
          finish: { label: 'Deposition Process', placeholder: 'e.g. Magnetron Sputtering' },
          material: { label: 'Functional Layer Material', placeholder: 'e.g. Ceramic Nitride' },
          thickness: { label: 'Film Thickness', placeholder: 'e.g. 2.5 mil' },
          internalNote: { label: 'Internal Note' }
        }
      },
      VINYL_WRAP: {
        name: 'Vinyl Wrap Film',
        fields: {
          material: { label: 'Face Film', placeholder: 'e.g. 160g PET Vinyl' },
          colorCode: { label: 'Color Code', placeholder: 'e.g. SN-P1-001-SG' },
          colorName: { label: 'Color Name', placeholder: 'e.g. Gloss Soft Cheek Peach Pink' },
          thickness: { label: 'Thickness', placeholder: 'e.g. 6.5MIL' },
          internalNote: { label: 'Internal Note' }
        }
      },
      HEADLIGHT: {
        name: 'Headlight Template',
        fields: {
          material: { label: 'Material', placeholder: 'e.g. TPU' },
          thickness: { label: 'Thickness', placeholder: 'e.g. 7.5MIL' },
          internalNote: { label: 'Internal Note' }
        }
      }
    }
  },
  warrantySummary: {
    title: 'Warranty Summary',
    totalProducts: 'Total Products',
    registered: 'Registered',
    expired: 'Expired',
    voided: 'Voided',
    storeSummary: 'Store Warranty Summary',
    storeName: 'Store Name',
    storeCode: 'Store Code',
    active: 'Active'
  },
  myProducts: {
    title: 'My Products',
    traceCode: 'Serial Number',
    traceCodePlaceholder: 'Enter serial number',
    productType: 'Product Type',
    productTypePlaceholder: 'Enter product type',
    productModel: 'Product Model',
    productModelPlaceholder: 'Enter product model',
    finishColor: 'Finish / Color (EN)',
    finishColorPlaceholder: 'Finish / color (English)',
    warranty: 'Warranty Period',
    createdAt: 'Created At',
    status: 'Status',
    hint: 'You can only view the products allocated to you by the administrator and their flow status; vehicle and owner data are hidden.'
  },
  cms: {
    title: 'Website Pages (CMS)',
    list: 'Page List',
    addPage: 'Add Page',
    editPage: 'Edit Page',
    pageCode: 'Page Code',
    pageTitle: 'Title',
    seoDescription: 'SEO Description',
    seoKeywords: 'SEO Keywords',
    content: 'Content',
    codePlaceholder: 'e.g. services, about',
    titlePlaceholder: 'Page title',
    descPlaceholder: 'SEO description',
    keywordsPlaceholder: 'keyword1, keyword2',
    contentPlaceholder: 'HTML content',
    confirmDelete: 'Are you sure to delete this page?'
  },
  settings: {
    title: 'Settings',
    site: 'Site',
    contact: 'Contact',
    email: 'Email',
    sms: 'SMS',
    order: 'Order',
    siteName: 'Site Name',
    siteLogo: 'Site Logo',
    siteDescription: 'Site Description',
    siteKeywords: 'Site Keywords',
    icpNumber: 'ICP Number',
    companyName: 'Company Name',
    serviceHotline: 'Service Hotline',
    contactEmail: 'Contact Email',
    businessHours: 'Business Hours',
    companyAddress: 'Company Address',
    smtpServer: 'SMTP Server',
    smtpPort: 'SMTP Port',
    smtpUsername: 'SMTP Username',
    smtpPassword: 'SMTP Password',
    fromEmail: 'From Email',
    fromName: 'From Name',
    enableSsl: 'Enable SSL',
    smsProvider: 'SMS Provider',
    selectProvider: 'Select provider',
    aliyunSms: 'Aliyun SMS',
    tencentSms: 'Tencent SMS',
    twilio: 'Twilio',
    accessKeyId: 'Access Key ID',
    accessKeySecret: 'Access Key Secret',
    smsSign: 'SMS Sign',
    templateCode: 'Template Code',
    defaultWarrantyDays: 'Default Warranty Days',
    reminderDaysBeforeExpiry: 'Reminder Days Before Expiry',
    autoArchiveAfterDays: 'Auto Archive After Days',
    enableSmsNotification: 'Enable SMS Notification',
    enableEmailNotification: 'Enable Email Notification',
    saveSettings: 'Save Settings',
    siteNamePlaceholder: 'Enter site name',
    logoPlaceholder: 'Enter logo URL',
    descPlaceholder: 'Enter description',
    icpPlaceholder: 'Enter ICP number',
    companyPlaceholder: 'Enter company name',
    hotlinePlaceholder: 'Enter hotline',
    emailPlaceholder: 'Enter contact email',
    hoursPlaceholder: 'e.g. 9:00-18:00',
    addressPlaceholder: 'Enter company address',
    smtpServerPlaceholder: 'e.g. smtp.gmail.com',
    smtpPortPlaceholder: 'e.g. 587',
    smtpUsernamePlaceholder: 'Enter SMTP username',
    smtpPasswordPlaceholder: 'Enter SMTP password',
    fromEmailPlaceholder: 'e.g. noreply@example.com',
    fromNamePlaceholder: 'Enter sender name',
    accessKeyPlaceholder: 'Enter access key',
    accessSecretPlaceholder: 'Enter access secret',
    smsSignPlaceholder: 'Enter SMS sign',
    templateCodePlaceholder: 'Enter template code'
  }
}
